import { Component } from '@angular/core';

@Component({
    selector: 'fe-pre-check-in',
    templateUrl: './pre-check-in.component.html',
    styleUrls: ['./pre-check-in.component.scss'],
})
export class PreCheckInComponent {}
